import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

export default function BuildRecognitionTopBar(props) {
  return (
    <div className="my-2 mx-8">
      <FontAwesomeIcon
        size="2x"
        className="text-slate-500 float-left cursor-pointer absolute top-8 left-8"
        icon={faArrowLeft}
        onClick={() => {
          props.returnFunction();
        }}
      />
      {!!props.title && (
        <div className="my-2 align-middle mx-8 text-sm font-bold">
          {props.title}
        </div>
      )}
      {!!props.bigTitle && (
        <div
          className="text-brandPrimary font-bold"
          style={{ fontSize: "120%" }}
        >
          {props.bigTitle}
        </div>
      )}
    </div>
  );
}
